import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { message, Divider, Table, Pagination, Row, Col, InputNumber, Radio, Button, Spin, Tabs, Tag, Space } from 'antd';
import API from '@api/api.js';
import styles from './index.module.scss'
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';
import UpdatePasswordModal from '@view/compoents/personalCenterModal/updatePasswordModal'
import PSAIModal from "@PSAIComponents/PSAIModal";
import QRCode from 'qrcode.react'
import Payment from '@view/compoents/Payment';
import dayjs from 'dayjs';
import JSZip from 'jszip';
import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";

// 支付
const DeliveryPayContent = (props) => {
    const {record, onClose} = props
    const payInfo = record.payInfo
    const [tradeId, setTradeId] = useState(payInfo.tradeId)
    const [payUrl, setPayUrl] = useState(payInfo.payUrl)
    const [dealAmount, setDealAmount] = useState(payInfo.dealAmount) // 待支付
    const [deductAmount, setDeductAmount] = useState(payInfo.deductAmount) // 余额
    const [channel, setChannel] = useState(record.channel)
    const [loading, setLoading] = useState(false)
    const [amount] = useState(record.amount)

    const extraRender = (
        <>
        {deductAmount > 0 && <p style={{fontSize: 16, textAlign:"center", marginBottom: 30}}>总计¥{amount}，支付后将从余额中扣除¥{deductAmount}</p>}
        <Row>
            <Col span={5} offset={4} style={{float: "right"}}>支付方式</Col>
            <Col span={12}>
                <Radio.Group value={channel} onChange={e => handleChannelChange(e.target.value)} >
                    <Radio className={styles.PayChannelRadio} value="alipay"><img className={styles.icon} src={require('@assets/images/icon_alipay.png')} />支付宝</Radio>
                    <Radio className={styles.PayChannelRadio} value="wechat"><img className={styles.icon} src={require('@assets/images/icon_wxpay.png')} />微信</Radio>
                </Radio.Group>
            </Col>
        </Row>
        </>
    )

    const handleChannelChange = (value) => {
        setLoading(true)
        API.payForDeliveryBill({
            id: record.id,
            channel: value,
            pay: false
        }).then(res => {
            if (res.code === 0) {
                const data = res.data
                if (data.needPay) { // 需要支付
                    setTradeId(data.tradeId)
                    setPayUrl(data.payUrl)
                    setDealAmount(data.dealAmount)
                    setDeductAmount(data.deductAmount)
                    setChannel(value)
                } else {
                    message.success("支付成功")
                    onClose()
                }
                console.log('支付', res.data)
            } else {
                message.warning(res.message)
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <Spin spinning={loading}>
            <Payment
                key={channel}
                title="结算"
                tradeId={tradeId}
                channel={channel}
                payUrl={payUrl}
                dealAmount={dealAmount}
                extraRender={extraRender}
                onClose={onClose}
            />
        </Spin>
    )
}

export default DeliveryPayContent
